import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { IconScreen } from "../IconScreen";

export const NoAccess = ({ url = "/" }: { url: string }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <IconScreen
      title={t("core:common:access_denied")}
      group="hifiDark"
      appearance="secondary"
      buttonText={t("core:common:return_to_home") as string}
      buttonOnClick={() => navigate(url)}
    />
  );
};
